export const PARTNER_STATUS_LIST_MUTATION = "PARTNER_STATUS_LIST_MUTATION";

export const BUSINESS_TYPE_LIST_MUTATION = "BUSINESS_TYPE_LIST_MUTATION";

export const PARTNER_GUBUNS_MUTATION = "PARTNER_GUBUNS_MUTATION";
